const CONVERGENT_ERRORS = {
  ConvergentBillingCompanyHasProperties: 'has_properties',
  ConvergentBillingCompanyHasBills: 'has_billing_data',
  ConvergentBillingCompanyHasCharges: 'has_billing_data',
  ConvergentBillingCompanyHasAllocationData: 'has_billing_data',
  ConvergentBillingCompanyHasBillingHistory: 'has_billing_data',
  ConvergentBillingCycleHasActivity: 'has_billing_data',
  ConvergentBillingCycleRunsToday: 'runs_today',
  ConvergentBillingToggleOnStatementDay: 'runs_today',
  ConvergentBillingAppfolioCompanyNotAllowed: 'appfolio',
  ConvergentBillingCompanySetupProcessing: 'processing',
  ConvergentBillingFeatureDisabled: 'unavailable'
};
export const convergentErrorKey = code => {
  var _CONVERGENT_ERRORS$co;
  return "company_details.convergent.errors.".concat((_CONVERGENT_ERRORS$co = CONVERGENT_ERRORS[code]) !== null && _CONVERGENT_ERRORS$co !== void 0 ? _CONVERGENT_ERRORS$co : 'generic');
};
export const getConvergentFieldState = _ref => {
  let companyId = _ref.companyId,
    flagEnabled = _ref.flagEnabled,
    isLivableAdmin = _ref.isLivableAdmin,
    isConvergent = _ref.isConvergent;
  return {
    show: Boolean(companyId) && flagEnabled && (isLivableAdmin || isConvergent),
    locked: isConvergent,
    showExplanation: isLivableAdmin,
    labelKey: isConvergent ? 'company_details.convergent.label_enabled' : 'company_details.convergent.label',
    explanationKey: isConvergent ? 'company_details.convergent.explanation_enabled' : 'company_details.convergent.explanation'
  };
};